import { Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TimePicker } from '@mui/x-date-pickers';
import clsx from 'clsx';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

export interface TimepickerProps extends Omit<ControllerProps, 'render'> {
  label?: string;
  disabled?: boolean;
  labelOut: boolean;
  className?: string;
}

export const Timepicker = ({
  name,
  label,
  className,
  disabled,
  labelOut,
  ...props
}: TimepickerProps): JSX.Element => {
  const methods = useFormContext();
  return (
    <FormControlLabel
      labelPlacement="top"
      className="m-0 w-full"
      label={
        <Typography
          className={clsx(
            { 'text-mui-error': methods.formState.errors[name] },
            'font-bold mb-1 ml-6'
          )}
          alignSelf="start"
        >
          {' '}
          {labelOut ? (
            <>
              {label}{' '}
              {!disabled ? (
                <span className="ml-1 text-mui-error">*</span>
              ) : null}
            </>
          ) : null}
        </Typography>
      }
      control={
        <Controller
          name={name}
          {...props}
          render={({ field, fieldState: { error } }) => (
            <TimePicker
              {...field}
              disabled={disabled}
              label={
                !labelOut ? (
                  <>
                    {label}
                    {props.rules?.required && !disabled && (
                      <span className="ml-1 text-mui-error">*</span>
                    )}
                  </>
                ) : null
              }
              className={className}
              ampm={false}
              slotProps={{
                textField: {
                  disabled: disabled,
                  helperText: error?.message,
                  size: 'small',
                  error: !!error,
                },
              }}
            />
          )}
        />
      }
    />
  );
};
